"use client"

import { SOURCE_FILTER_ROW, sourceFilterPill } from "@/components/source-filter-pill"

export type CivitaiMediaType = "all" | "image" | "video"

interface CivitaiMediaTypeTabsProps {
  value: CivitaiMediaType
  onChange: (value: CivitaiMediaType) => void
}

const OPTIONS: { value: CivitaiMediaType; label: string }[] = [
  { value: "all", label: "All" },
  { value: "image", label: "Image" },
  { value: "video", label: "Video" },
]

// Mirrors Civitai's own "Filter by Media Type" control — Image/Video already
// has a real server-side param (see app/api/booru/civitai/search/route.ts and
// lib/booru-sources/civitai.ts), this is just the first UI ever wired to it.
export function CivitaiMediaTypeTabs({ value, onChange }: CivitaiMediaTypeTabsProps) {
  return (
    <div className={SOURCE_FILTER_ROW}>
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={sourceFilterPill(isActive)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
